(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.investment-investor-blocked-dialog', [
    'pp.widgets-templates',
    'pp.services.route'
]);

ngModule.component('ppInvestmentInvestorBlockedDialog', {
    templateUrl: 'widgets/_angular/investment-investor-blocked-dialog/investment-investor-blocked-dialog.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', 'routeService', function ($scope, routeService) {
        var vm = this;

        // -- initial state
        vm.marketplacePath = routeService.marketplacePath;
        vm.contactUsPath = routeService.contactUsPath;

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);